/* Claude Vintage — entrance + scroll reveal */
(function () {
  if (window.__cvInit) { return; }
  window.__cvInit = true;
  function init() {
    document.querySelectorAll('.cv-hero').forEach(function (h) { h.classList.add('cv-loaded'); });
    document.querySelectorAll('.cv-hero-image img, .cv-editorial-img').forEach(function (el) {
      if (el.tagName === 'IMG') {
        if (el.complete) { el.classList.add('cv-in'); }
        else { el.addEventListener('load', function () { el.classList.add('cv-in'); }); }
      } else {
        var img = el.querySelector('img');
        if (!img || img.complete) { el.classList.add('cv-in'); }
        else { img.addEventListener('load', function () { el.classList.add('cv-in'); }); }
      }
    });

    var reveal = document.querySelectorAll('.cv-r');
    if (!('IntersectionObserver' in window)) {
      reveal.forEach(function (el) { el.classList.add('cv-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('cv-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.1 });
    reveal.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
